import { Box, Button, Chip, Grid, IconButton, MenuItem, Stack, TextField, Tooltip, Typography } from '@mui/material';
import React, { useMemo, useState } from 'react';
import AppWrapper from '../../AppWrapper';
import ContentLoader from '../../components/ContentLoader';
import useAuth from '../../hooks/useAuth';
import CardQuick from '../../components/Card';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import {
  useQuery,
} from '@tanstack/react-query';
import MaterialReactTable from 'material-react-table';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useNavigate } from 'react-router-dom';
import { commonService } from '../../services';
import StyledChip from '../../components/StyledChip';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DatePickerField from '../../components/DatePickerField';
import ClearAllIcon from '@mui/icons-material/ClearAll';



const ValidationsPage = () => {
  const { user } = useAuth();
  const navigate = useNavigate()
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState('');
  const [sorting, setSorting] = useState([]);
  const [locationId, setLocationId] = useState(0);
  const [cardNumber, setCardNumber] = useState('');
  const [validationStatus, setValidationStatus] = useState(0);
  const [name, setName] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);



  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const { data, isError, isFetching, isLoading, refetch } =
    useQuery(
      [
        'table-data',
        columnFilters,
        globalFilter,
        pagination.pageIndex,
        pagination.pageSize,
        sorting,
        locationId,
        cardNumber,
        name,
        validationStatus,
        startDate,
        endDate
      ],
      async () => {
        const axiosData = await commonService.usageList(pagination, sorting[0]?.id, sorting[0]?.desc, locationId, cardNumber, validationStatus, name,startDate,endDate)
        console.log(sorting)
        return axiosData;
      },
      { keepPreviousData: false },
    );

  const columns = useMemo(
    () => [
      {
        id: 'c.name',
        accessorKey: 'card_name',
        header: 'Cliente',
      },
      {
        id: 'c.number',
        accessorKey: 'card',
        header: 'Nº de Cartão',
      },
      {
        id: 'l.name',
        accessorKey: 'location_name',
        header: 'Local de Prestação',
      },
      {
        id: 'ab.created_at',
        accessorKey: 'created_at',
        header: 'Data',
      },
      {
        accessorKey: 'order_status_name',
        header: 'Estado',
        muiTableHeadCellProps: {
          align: 'right',
        },
        muiTableBodyCellProps: {
          align: 'right',
        },
        Cell: ({ cell, row }) => (
          <Chip label={row.original.validation_status == 1 ? 'Ativo' : 'Inativo'} color={row.original.validation_status == 1 ? 'success' : 'error'} />
        ),
      },
    ],
    [],
  );
  const clearFilters = () => {
    setStartDate(null);
    setEndDate(null);
    setLocationId(0);
    setCardNumber('');
    setName('');


  }
  return (
    <React.Fragment>

      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Typography variant='h1' fontWeight={600}>Validações</Typography>
        </Grid>
        <Grid item xs={12}>
          <CardQuick

            headerSx={{
              '& .MuiCardHeader-title': {
                fontSize: '16pt',
                fontWeight: 'bolder'
              },
            }}

            wrapperSx={{ pt: 1 }}
            action={
              <Stack
                direction="row"
                justifyContent="flex-end"
                alignItems="flex-end"
                spacing={0.5}
              >
              </Stack>
            }
          >
            <Box style={{ display: 'flex', gap: 9 }}>
              <Grid container spacing={4}>
                <Grid item xs={2}>
                  <TextField
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                          borderRadius: 8,
                        },

                      },
                    }}
                    select
                    size="small"
                    defaultValue=""
                    fullWidth

                    variant="outlined"
                    value={locationId}
                    label='Local de prestação'
                    onChange={(e) => {
                      setLocationId(e.target.value);
                      //Pesquisa Novamente
                    }}
                  >
                    <MenuItem value={0}>Todos os Locais</MenuItem>
                    {user?.locations?.map((option) => (
                      <MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={2}>

                  <TextField
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                          borderRadius: 8,
                        },
                 

                      },
                    }}
                    select
                    size="small"
                    defaultValue=""
                    fullWidth
                    variant="outlined"
                    value={validationStatus}
                    label='Estado'
                    onChange={(e) => {
                      setValidationStatus(e.target.value);
                      //Pesquisa Novamente
                    }}
                  >
                    <MenuItem value={0}>Todos</MenuItem>
                    <MenuItem value={1}>Ativo</MenuItem>
                    <MenuItem value={2}>Expirado</MenuItem>
                    <MenuItem value={3}>Inválido</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                          borderRadius: 8,
                        },
                      },
                    }}
                    size="small"
                    defaultValue=""
                    variant="outlined"
                    label="Nº de Cartão"
                    value={cardNumber}
                    fullWidth

                    onChange={(e) => {
                      setCardNumber(e.target.value);
                      //Pesquisa Novamente
                    }}
                  />
                </Grid>

                <Grid item xs={2}>
                  <TextField
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                          borderRadius: 8,
                        },
                      },
                    }}
                    size="small"
                    defaultValue=""
                    variant="outlined"
                    fullWidth

                    label="Nome"
                    value={name}
                    onChange={(e) => {
                      setName(e.target.value);
                      //Pesquisa Novamente
                    }}
                  />
                </Grid>
                <Grid item xs={6} sm={1.5}>

                  <DatePickerField fullWidth label="De" value={startDate} onChange={(e) => {
                    setStartDate(e.target.value)
                  }} />
                </Grid>
                <Grid item xs={6} sm={1.5}>

                  <DatePickerField fullWidth label="Até" value={endDate} onChange={(e) => {
                    setEndDate(e.target.value)
                  }} />
                </Grid>
                <Grid item xs={6} sm={0.5}>
                <IconButton>
                  <ClearAllIcon color='primary' onClick={() => { clearFilters() }} />
                </IconButton>
              </Grid>
              </Grid>
            </Box>
            <MaterialReactTable
              columns={columns}
              data={data?.rows ?? []} //data is undefined on first render
              initialState={{ showColumnFilters: false, density: 'compact' }}
              manualFiltering
              manualPagination
              manualSorting
              localization={MRT_Localization_PT_BR}
              muiToolbarAlertBannerProps={
                isError
                  ? {
                    color: 'error',
                    children: 'Erro ao tentar carregar lista.',
                  }
                  : undefined
              }
              onColumnFiltersChange={setColumnFilters}
              onGlobalFilterChange={setGlobalFilter}
              onPaginationChange={setPagination}
              onSortingChange={setSorting}
              renderTopToolbarCustomActions={() => (
                <Tooltip arrow title="Refresh Data">
                  <IconButton onClick={() => refetch()}>
                    <RefreshIcon />
                  </IconButton>
                </Tooltip>
              )}
              enableFilters={false}
              enableFullScreenToggle={false}
              enableDensityToggle={false}
              rowCount={data?.totalRowCount ?? 0}
              state={{
                columnFilters,
                globalFilter,
                isLoading,
                pagination,
                showAlertBanner: isError,
                showProgressBars: isFetching,
                sorting,
              }}
              muiTableBodyCellProps={{ sx: { backgroundColor: '#FFFFFF' } }}
              muiTablePaginationProps={{ sx: { backgroundColor: '#FFFFFF' } }}
              muiBottomToolbarProps={{ sx: { backgroundColor: '#FFFFFF' } }}
              muiTopToolbarProps={{ sx: { backgroundColor: '#FFFFFF' } }}
              muiTableHeadRowProps={{ sx: { backgroundColor: '#FFFFFF' } }}
              muiTablePaperProps={{ sx: { boxShadow: 'none' } }}

            />
          </CardQuick>
        </Grid>
      </Grid>

      {/*       <ContentLoader open={isLoading} />
 */}          </React.Fragment>


  )
}

export default ValidationsPage;